module.exports = __webpack_public_path__ + "static/media/chargixpro-3.9a0f0993.jpg";